import { Component } from '@angular/core'
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatDialogRef } from '@angular/material/dialog'
import { EducationService } from '../../services/education/education.service'
import { HttpErrorResponse } from '@angular/common/http'
import { ToastrService } from 'ngx-toastr'
import { Education, EducationDTO } from '../../models/education.interface'
import { MatStepperModule } from '@angular/material/stepper'
import {
    MatError,
    MatFormField,
    MatFormFieldModule,
    MatLabel,
} from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatIcon, MatIconModule } from '@angular/material/icon'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatRadioModule } from '@angular/material/radio'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatSelectModule } from '@angular/material/select'
import { MatNativeDateModule } from '@angular/material/core'
import { NgFor, NgIf } from '@angular/common'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import {
    educationLevel,
    lengueageProperty,
} from '../incident-observatorio/incident-form/incident.definitions'

@Component({
    selector: 'app-education-form',
    standalone: true,
    imports: [
        MatStepperModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatError,
        MatIcon,
        MatIconModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        NgIf,
        NgFor,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
    ],
    templateUrl: './education-form.component.html',
    styleUrl: './education-form.component.css',
})
export class EducationFormComponent {
    selectedEducation: Education | null = null
    educationId: string | null = null
    errorMsg: string[] | null = null
    educationLevel = educationLevel
    lengueageProperty = lengueageProperty
    constructor(
        private dialogRef: MatDialogRef<EducationFormComponent>,
        private fb: FormBuilder,
        private educationService: EducationService,
        private toastr: ToastrService
    ) {}

    ngOnInit(): void {
        this.educationService.$educationsSelected.subscribe((education) => {
            if (education) {
                this.educationId = String(education.id)
                this.selectedEducation = education
                this.editEducationForm.patchValue({
                    ...education,
                })
            }
        })
    }

    editEducationForm = this.fb.group({
        level: ['', []],
        culturalKnowledge: ['', []],
        nasaYuwe: ['', []],
        isIlliterate: [false],
    })

    closeDialog() {
        this.dialogRef.close()
    }

    updateEducation() {
        const payload = this.editEducationForm.value as EducationDTO
        if (this.editEducationForm.status === 'VALID' && this.educationId) {
            if (this.editEducationForm.pristine) {
                this.dialogRef.close()
                return
            }
            const id = Number(this.educationId)
            this.educationService
                .updateEducation(id, { ...payload, id: id })
                .subscribe({
                    next: (education) => {
                        const msg = `El registro fue EDITADO correctamente!`
                        this.toastr.success(msg, 'Exitoso!', {
                            progressBar: true,
                            timeOut: 5000,
                        })
                        this.dialogRef.close()
                    },
                    error: ({}: HttpErrorResponse) => {
                        if (this.errorMsg) {
                            this.toastr.error(
                                'Error: ' + this.errorMsg,
                                undefined,
                                {
                                    progressBar: true,
                                    timeOut: 5000,
                                }
                            )
                        }
                    },
                })
        }
    }
}
